/** 标签栏展开图标。 */
export function OpenSlideIcon() {
    return (
        <svg className="tabs-control-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
                d="M17 4.32983C17.4142 4.32983 17.75 4.66562 17.75 5.07983C17.75 5.49405 17.4142 5.82983 17 5.82983H3C2.58579 5.82983 2.25 5.49405 2.25 5.07983C2.25 4.66562 2.58579 4.32983 3 4.32983H17Z"
                fill="currentColor"
            />
            <path
                d="M16.5156 9.18117C16.9298 9.18122 17.2656 9.51699 17.2656 9.93117C17.2656 10.3453 16.9298 10.6811 16.5156 10.6812H10C9.58579 10.6812 9.25 10.3454 9.25 9.93117C9.25 9.51695 9.58579 9.18117 10 9.18117H16.5156Z"
                fill="currentColor"
            />
            <path
                d="M16.5156 14.0107C16.9298 14.0108 17.2656 14.3466 17.2656 14.7607C17.2656 15.1749 16.9298 15.5107 16.5156 15.5107H10C9.58579 15.5107 9.25 15.175 9.25 14.7607C9.25 14.3465 9.58579 14.0107 10 14.0107H16.5156Z"
                fill="currentColor"
            />
            <path d="M3 10.9202L6 12.9202L3 14.9202V10.9202Z" fill="currentColor" />
            <path
                d="M2.64648 10.259C2.89031 10.1287 3.18595 10.1428 3.41602 10.2961L6.41602 12.2961C6.62466 12.4352 6.75 12.6694 6.75 12.9202C6.75 13.1709 6.62466 13.4051 6.41602 13.5442L3.41602 15.5442C3.18595 15.6976 2.89031 15.7117 2.64648 15.5813C2.40262 15.4508 2.25 15.1968 2.25 14.9202V10.9202C2.25 10.6436 2.40262 10.3896 2.64648 10.259ZM3.75 13.5188L4.64746 12.9202L3.75 12.3215V13.5188Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default OpenSlideIcon;
